{
  "login": {
    "title": "साइन इन करें",
    "subtitle": "हम उस ईमेल पते का सुझाव देते हैं जिसका आप कार्यस्थल में उपयोग करते हैं।",
    "signInTab": "साइन इन",
    "signUpTab": "साइन अप",
    "emailLabel": "ईमेल*",
    "emailPlaceholder": "अपना ईमेल पता दर्ज करें",
    "passwordLabel": "पासवर्ड*",
    "passwordPlaceholder": "अपना पासवर्ड दर्ज करें",
    "forgotPassword": "पासवर्ड भूल गए?",
    "submit": "साइन इन करें",
    "submitting": "प्रस्तुत कर रहे हैं..."
  },
  "forgotPassword": {
    "title": "पासवर्ड भूल गए",
    "subtitle": "कोई चिंता नहीं, हम आपको पासवर्ड रीसेट करने के निर्देश भेजेंगे।",
    "emailLabel": "ईमेल*",
    "emailPlaceholder": "अपना ईमेल पता दर्ज करें",
    "resetButton": "पासवर्ड रीसेट करें",
    "submitting": "प्रस्तुत कर रहे हैं...",
    "backToSignIn": "साइन इन पर वापस जाएं"
  },
  "otpVerification": {
    "errorIncomplete": "कृपया सभी 4 अंकों को दर्ज करें",
    "verifying": "जांच रही है...",
    "verify": "जांचें",
    "notReceived": "नहीं मिला?",
    "resend": "फिर से भेजने के लिए यहां क्लिक करें।",
    "backToSignUp": "साइन अप पर वापस जाएं"
  },
  "register": {
    "setupAccount": "अपना खाता सेट करें",
    "personalizeExperience": "आइए आपके व्यवसाय की जरूरतों के अनुसार आपका अनुभव व्यक्तिगत बनाएं।",
    "signUp": "साइन अप",
    "firstName": "पहला नाम*",
    "firstNamePlaceholder": "अपना पहला नाम दर्ज करें",
    "lastName": "अंतिम नाम*",
    "lastNamePlaceholder": "अपना अंतिम नाम दर्ज करें",
    "email": "ईमेल*",
    "emailPlaceholder": "अपना ईमेल पता दर्ज करें",
    "phoneNumber": "फ़ोन नंबर*",
    "phonePlaceholder": "अपना फोन नंबर दर्ज करें",
    "next": "आगे",
    "brandName": "ब्रांड नाम*",
    "brandNamePlaceholder": "अपना ब्रांड नाम दर्ज करें",
    "sector": "क्षेत्र*",
    "password": "पासवर्ड*",
    "passwordPlaceholder": "अपना पासवर्ड दर्ज करें",
    "confirmPassword": "पासवर्ड की पुष्टि करें*",
    "confirmPasswordPlaceholder": "अपना पासवर्ड फिर से दर्ज करें",
    "back": "वापस",
    "submitting": "प्रस्तुत किया जा रहा है...",
    "selectSector": "क्षेत्र चुनें..."
  },
  "countries": {
    "us": "संयुक्त राज्य",
    "ca": "कनाडा",
    "in": "भारत"
  },
  "resetPassword": {
    "title": "पासवर्ड भूल गए",
    "subtitle": "नया पासवर्ड आपके पहले उपयोग किए गए पासवर्ड से अलग होना चाहिए।",
    "password": "पासवर्ड*",
    "passwordPlaceholder": "अपना पासवर्ड दर्ज करें",
    "confirmPassword": "पासवर्ड की पुष्टि करें*",
    "confirmPasswordPlaceholder": "अपना पासवर्ड दोबारा दर्ज करें",
    "submit": "पासवर्ड रीसेट करें",
    "submitting": "रीसेट किया जा रहा है..."
  },
  "thankYou": {
    "title": "AWS के साथ साइन अप करने के लिए धन्यवाद",
    "subtitle": "आप तुरंत टूल का उपयोग शुरू कर सकते हैं।",
    "button": "जारी रखें"
  },
  "adsAnalysis": {},
  "staticPages": {
    "priceSection": {
      "couponCode": "कूपन कोड",
      "apply": "लागू करें"
    }
  }
}